import { render, staticRenderFns } from "./WhoWeAre1.vue?vue&type=template&id=c8c8744e&scoped=true&"
import script from "./WhoWeAre1.vue?vue&type=script&lang=js&"
export * from "./WhoWeAre1.vue?vue&type=script&lang=js&"
import style0 from "./WhoWeAre1.vue?vue&type=style&index=0&id=c8c8744e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c8744e",
  null
  
)

export default component.exports